<script lang="ts">
  import './app.css'
  import './app.styl'

  import { t } from 'i18next'

  import { appState } from './store/appState.svelte.ts'

  import { notifications } from './store/notifications.svelte.ts'

  import AppContent from './components/AppContent.svelte'
  import AppHeader from './components/AppHeader.svelte'
  import AppSideMenuWrapper from './components/AppSideMenuWrapper.svelte'
  import ZNotification from './components/ZNotification.svelte'
  import { useRouter } from './routes.svelte.ts'

  // -------------------------------------------------------------------

// const testⵅ = 1
// const testⵙ = 1
// const testᐅ = 1

// -------------------------------------------------------------------

  const rt = useRouter()

  // -------------------------------------------------------------------

  let waitingForReadyMs = $state(0)
  const startMs = Date.now()

  $effect(() => {
    if (!appState.isReadyForAction) {
      waitingForReadyMs = Date.now() - startMs
    }
  })

  // -------------------------------------------------------------------

  const waitingTakesABbitLongerSoShowSpinnerMeanwhile = $derived(waitingForReadyMs > 1000)
  const waitingTookTooLong = $derived(waitingForReadyMs > 2000) // 30000? (5000 for testing)

  // -------------------------------------------------------------------

  function isLoginOrRegisterOrTest (): boolean {
    return rt.params.isLogin === true || rt.params.isRegister === true || rt.params.isTest === true
  }

  // -------------------------------------------------------------------

  const showDebugPane = false
</script>

<!-- ------------------------------------------------------------- -->

<div class="z-app-body flex grow flex-col">
  {#if appState.isReadyForAction}
    {#if !(isLoginOrRegisterOrTest() && appState.isCheckingForLogin !== true)}
      <AppHeader />

      <div
        class="
          max-w-content-max pointer-events-none fixed left-0 right-0 top-[40px]
          z-50 mx-auto flex flex-col items-center gap-2 p-3
        "
      >
        {#each notifications as notification (notification.id)}
          <div class="pointer-events-auto">
            <ZNotification
              id={notification.id}
              allowHide={notification.allowHide}
              icon={notification.icon}
              links={notification.links}
              onClick={notification.onClick}
              onClose={notification.onClose}
              title={notification.title}
              type={notification.type}
            />
          </div>
        {/each}
      </div>
    {/if}

    {#if showDebugPane}
      <div class="flex grow flex-row">
        <AppContent>
          {@const Page = rt.page}
          <Page params={rt.params} />
        </AppContent>
        <pre id="pz-debug-pane"><div>Debug pane</div></pre>
      </div>
    {:else}
      {#if !(isLoginOrRegisterOrTest() && appState.isCheckingForLogin !== true)}
        <AppContent>
          {@const Page = rt.page}
          <Page params={rt.params} />
        </AppContent>
      {:else}
        {@const Page = rt.page}
        <Page params={rt.params} />
      {/if}
    {/if}

    <AppSideMenuWrapper />
  {:else if isLoginOrRegisterOrTest() && appState.isCheckingForLogin !== true}
    <div class="flex grow flex-col items-center justify-center">
      {#if true}
        {@const Page = rt.page}
        <Page params={rt.params} />
      {/if}
    </div>
  {:else}
    <div class="flex grow flex-col items-center justify-center">
      {#if waitingTookTooLong}
        <div>
          {t('Something went wrong while getting things ready!')}
          <br />
          {t('Try refreshing the page, restarting the browser or using another browser, like Chrome, Safari or Edge,')}
          <br />
          <!-- TODO Show diagnostic info? -->
          <br />
          isCheckingForLogin: {appState.isCheckingForLogin}<br />
          isReadyForAction: {appState.isReadyForAction}<br />
          isLoggedInAndIdKnown: {appState.isLoggedInAndIdKnown}<br />
          isInstanceKnown: {appState.isInstanceKnown}<br />
          isSpacesKnown: {appState.isSpacesKnown}<br />
          <!-- activeSpace?.db: {appState.activeSpace?.db}<br /> -->
          <!-- instance?.db: { appState.instance?.db }<br /> -->
          userDb: {appState.userDb}<br />
          authState: {appState.authState}<br />
          authenticatedUser: {JSON.stringify(appState.authenticatedUser)}<br />
          authenticatedUser?.id: {appState.authenticatedUser?.id}<br />
        </div>
      {:else if waitingTakesABbitLongerSoShowSpinnerMeanwhile}
        <div aria-busy="true">
          &nbsp; {t('Getting things ready...')}
        </div>
      {:else}
        <div>...</div>
        <!-- waitingTakesABbitLongerSoShowSpinnerMeanwhile: { waitingTakesABbitLongerSoShowSpinnerMeanwhile }<br />
        waitingTookTooLong: { waitingTookTooLong }<br /> -->
      {/if}
    </div>
  {/if}

  <div class="alpha-msg">
    {appState.appVersion}
  </div>
</div>

<!-- ------------------------------------------------------------- -->

<style lang="stylus">
.z-app-body
  width 100%
  height 100%

.alpha-msg
  font-size: 11px;
  color: #888;
  background-color: #ffffffb3;
  font-weight: 500;
  right: 0;
  bottom: 4px;
  position: fixed;
  pointer-events: none;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  z-index: 999999;

#pz-debug-pane
  background-color #444
  color white
  font-size 9px
  line-height 11px
  font-family monospace
  max-width min(300px, 30vw)
  max-height 90vh
  overflow auto
  margin 2px 0
  padding 1px 4px
  overflow-wrap break-word
  white-space pre-wrap

  & :global(> *)
    max-width 300px
    line-break anywhere
    white-space pre-wrap
    padding-bottom 2px;
    margin-bottom 2px;
    border-bottom 1px solid #888

  :global(.pz-dbg-cnt-node)
    margin-left 8px
    color pink
</style>
